import React, { FC, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import moment from 'moment-mini'
import Header from '../../Header'
import Footer from '../../Footer'
import { AppState } from '../../../reducers'
import { setUIForwardAction, setUIBackwardsAction, setErrorAction } from '../../../actions'
import { UI } from '../../../constants/ui'
import './confirmReservation.less'
import FooterMobile from '../../FooterMobile'
import { getMode } from '../../../hooks/mode'
import { MODE } from '../../../constants/mode'

const mapStateToProps = (state: AppState) => ({
  reservation: state.reservation.reservation,
  reservationChange: state.reservationChange,
})

const mapDispatchToProps = {
  setUIForward: setUIForwardAction,
  setUIBackwards: setUIBackwardsAction,
  setError: setErrorAction,
}

type DispatchProps = typeof mapDispatchToProps
type StateProps = ReturnType<typeof mapStateToProps>
type Props = StateProps & DispatchProps

const ConfirmReservationMobile: FC<Props & { isTodayDeparture: boolean }> = (props: Props & { isTodayDeparture: boolean }) => {
  const { setUIForward, reservation, reservationChange, setError, isTodayDeparture } = props
  const { t } = useTranslation()

  if (!reservation) {
    return null
  }
  return (
    <div className="confirm-reservation-mobile">
      <div className="confirm-reservation-mobile-wrapper">
        <div className="reservation-title" dangerouslySetInnerHTML={{ __html: t('confirmReservationBookingCorrect') }}></div>
        <div className="reservation-data">
          <div className="way-and-date">
            <div className="way">
              <span className="text-bold">{t(reservation.route.portFrom)}</span>
              &nbsp;
              <span className="gray-text">
                <span className="text-bold">{'→'}</span>
              </span>
              &nbsp;<span className="text-bold">{t(reservation.route.portTo)}</span>
            </div>
            <div className="date">
              {!isTodayDeparture && <div className="number">{moment(reservation.route.dateFrom).format('DD')}</div>}
              <div className="without-number">
                {!isTodayDeparture && (
                  <>
                    {t(moment(reservation.route.dateFrom).format('MMMM'))},{' '}
                    {moment(reservation.route.dateFrom).format('YYYY')}
                    <br />
                  </>
                )}
                {isTodayDeparture && (
                  <div
                    className="text-for-time"
                    dangerouslySetInnerHTML={{ __html: t('confirmReservationTodayAt') }}
                  ></div>
                )}
                <div className="time">
                  <span className="text-bold">{moment(reservation.route.dateFrom).format('HH:mm')}</span>
                  <span className="gray-text">
                    &nbsp;{'→'}&nbsp;
                    {moment(reservation.route.dateTo).format('HH:mm')}
                  </span>
                </div>
              </div>
            </div>
            {reservation.route.ship}
          </div>
          <div className="about-drivers-and-cargo">
            {reservation.customerName}
            <div className="regNumber-and-passengers">
              {t(reservation.cargoType)} <span className="text-bold">{reservationChange.carLicencePlate}</span>
            </div>
            <div>
              {reservation.drivers[0] && `${reservation.drivers[0].firstName} ${reservation.drivers[0].lastName}`}
              {reservation.drivers[1] && reservation.drivers[1].lastName ? ',' : ''}
            </div>
            <div>
              {reservation.drivers[1] && (reservation.drivers[1].firstName || reservation.drivers[1].lastName)
                ? `${reservation.drivers[1].firstName} ${reservation.drivers[1].lastName}`
                : ''}
            </div>
          </div>
        </div>
        <div className="buttons">
            <button className="main-button-mobile" onClick={() => setUIForward(UI.DANGEROUS_GOODS)}>
              {t('confirmReservationYesButton')}
            </button>
            <button
              className="cancel-button-mobile"
              onClick={() => {
                setError('turnToCheckInCounter', '')
              }}
            >
              {t('confirmReservationWrongBooking')}
            </button>
        </div>
      </div>
      <div className="footer-mobile-container">
        <FooterMobile showPageCount />
      </div>
    </div>
  )
}

const ConfirmReservationDesktop: FC<Props & { isTodayDeparture: boolean }> = (props: Props & { isTodayDeparture: boolean }) => {
  const { setUIForward, setUIBackwards, reservation, reservationChange, setError, isTodayDeparture } = props
  const { t } = useTranslation()

  if (!reservation) {
    return null
  }
  return (
    <>
      <Header showPageCount back={() => setUIBackwards(UI.MAIN)} />
      <div className="confirm-reservation">
        <div className="reservation-title" dangerouslySetInnerHTML={{ __html: t('confirmReservationBookingCorrect') }}></div>
        <div className="reservation-data">
          <div className="way-and-date">
            <div className="way">
              <span className="text-bold">{t(reservation.route.portFrom)}</span>
              &nbsp;
              <span className="gray-text">
                <span className="text-bold">{'→'}</span>
              </span>
              &nbsp;<span className="text-bold">{t(reservation.route.portTo)}</span>
            </div>
            <div className="date">
              {!isTodayDeparture && <div className="number">{moment(reservation.route.dateFrom).format('DD')}</div>}
              <div className="without-number">
                {!isTodayDeparture && (
                  <>
                    {t(moment(reservation.route.dateFrom).format('MMMM'))},{' '}
                    {moment(reservation.route.dateFrom).format('YYYY')}
                    <br />
                  </>
                )}
                {isTodayDeparture && (
                  <div
                    className="text-for-time"
                    dangerouslySetInnerHTML={{ __html: t('confirmReservationTodayAt') }}
                  ></div>
                )}
                <div className="time">
                  <span className="text-bold">{moment(reservation.route.dateFrom).format('HH:mm')}</span>
                  <span className="gray-text">
                    &nbsp;{'→'}&nbsp;
                    {moment(reservation.route.dateTo).format('HH:mm')}
                  </span>
                </div>
              </div>
            </div>
            {reservation.route.ship}
          </div>
          <div className="about-drivers-and-cargo">
            {reservation.customerName}
            <div className="regNumber-and-passengers">
              {t(reservation.cargoType)} <span className="text-bold">{reservationChange.carLicencePlate}</span>
            </div>
            <div>
              {reservation.drivers[0] && `${reservation.drivers[0].firstName} ${reservation.drivers[0].lastName}`}
              {reservation.drivers[1] && reservation.drivers[1].lastName ? ',' : ''}
            </div>
            <div>
              {reservation.drivers[1] && (reservation.drivers[1].firstName || reservation.drivers[1].lastName)
                ? `${reservation.drivers[1].firstName} ${reservation.drivers[1].lastName}`
                : ''}
            </div>
          </div>
        </div>
        <div className="buttons">
          <div className="buttons-row">
            <button className="main-button" onClick={() => setUIForward(UI.DANGEROUS_GOODS)}>
              {t('confirmReservationYesButton')}
            </button>
            <button
              className="cancel-button"
              onClick={() => {
                setError('turnToCheckInCounter', '')
              }}
            >
              {t('confirmReservationWrongBooking')}
            </button>
          </div>
        </div>
      </div>
      <Footer />
    </>
  )
}


const ConfirmReservation: React.FC<Props> = (props: Props) => {
  const { reservation } = props
  const [isTodayDeparture, setTodayDeparture] = useState<boolean>(false)
  const mode = getMode()

  useEffect(() => {
    reservation &&
      setTodayDeparture(
        moment(reservation.route.dateFrom)
          .endOf('day')
          .isSame(moment().endOf('day')),
      )
  }, [reservation])

  if (mode === MODE.MOBILE) {
    return <ConfirmReservationMobile {...props} isTodayDeparture={isTodayDeparture} />
  } else {
    return <ConfirmReservationDesktop {...props} isTodayDeparture={isTodayDeparture} />
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmReservation)
